import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { EoiLink } from "./EoiLink";

const LINKS = [
  { label: "Our Ethos", href: "/#ethos", testid: "nav-link-ethos" },
  { label: "Academic Model", href: "/#academics", testid: "nav-link-academics" },
  { label: "Key Dates", href: "/#key-dates", testid: "nav-link-key-dates" },
];

export const Nav = () => (
  <motion.header
    initial={{ y: -24, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
    className="sticky top-0 z-50 border-b border-slate-200 bg-white/90 backdrop-blur-md"
  >
    <nav className="mx-auto flex w-full max-w-7xl items-center justify-between px-4 py-3 sm:px-6 lg:px-12">
      <Link to="/" className="flex items-center gap-3" data-testid="nav-brand-logo">
        <Logo className="h-9 w-9" />
        <span className="flex flex-col leading-none">
          <span className="font-serif text-lg font-bold tracking-wide text-navy">VPS</span>
          <span className="font-mono text-[9px] tracking-[0.2em] text-slate-500">
            YEARS 7–10 · OPENING 2027
          </span>
        </span>
      </Link>

      <div className="hidden items-center gap-8 md:flex">
        {LINKS.map((l) => (
          <a
            key={l.href}
            href={l.href}
            data-testid={l.testid}
            className="text-sm font-medium text-slate-600 transition-colors duration-300 hover:text-navy"
          >
            {l.label}
          </a>
        ))}
      </div>

      <EoiLink
        testid="nav-eoi-button"
        className="group flex items-center gap-1.5 whitespace-nowrap rounded-full bg-gold px-5 py-3 text-sm font-semibold tracking-wide text-black shadow-lg shadow-gold/30 transition-all duration-200 hover:bg-gold-hover hover:shadow-xl hover:shadow-gold/40 active:scale-95 sm:gap-2 sm:px-9 sm:py-4 sm:text-base"
      >
        Express Your Interest
        <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </EoiLink>
    </nav>
  </motion.header>
);
